var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Watch } from 'vue-property-decorator';
import GlobalVue from "../../../globalVue";
import VueDialog from "../../../interface/IVueDialog";
import OrderService from '../../../api/OrderService';
import CommonService from '../../../api/CommonService';
import { EPurOrderErrorCode } from "../../../enum/EPurchaseOrderCode";
import ArticleList from "../../../components/alert/ArticleList.vue";
import Client from '../../client/List.vue';
var SendGoodsDialog = (function (_super) {
    __extends(SendGoodsDialog, _super);
    function SendGoodsDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.outOrgans = [];
        _this.storeOptions = [];
        _this.order_id = '';
        _this.formData = {
            outOrganId: '',
            depot_id: ''
        };
        return _this;
    }
    SendGoodsDialog.prototype.watch_outOrganId = function (newValue, oldValue) {
        if (newValue) {
            if (oldValue) {
                this.formData.depot_id = '';
            }
            this.getStoreOptions(newValue);
        }
        else {
            this.storeOptions = [];
            this.formData.depot_id = '';
        }
    };
    SendGoodsDialog.prototype.created = function () {
        this.service = OrderService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getOutOrgan();
    };
    SendGoodsDialog.prototype.getOutOrgan = function () {
        var _this = this;
        this.service.getOutOrgan({
            order_id: this.order_id
        }).then(function (res) {
            _this.outOrgans = res.data.data || [];
            if (!_this.outOrgans) {
                _this.$message.error('请初始化仓库！');
                return;
            }
            if (_this.outOrgans[0]) {
                _this.formData.outOrganId = _this.outOrgans[0].value;
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    SendGoodsDialog.prototype.getStoreOptions = function (organ_id) {
        var _this = this;
        this.service.getStoreOptions({
            organ_id: organ_id,
            is_init: 1
        }).then(function (res) {
            _this.storeOptions = res.data.data || [];
            if (!_this.storeOptions.length) {
                return;
            }
            for (var i = 0; i < _this.storeOptions.length; i++) {
                if (_this.storeOptions[i].is_organ_default == 1) {
                    _this.formData.depot_id = _this.storeOptions[i].depot_id;
                    break;
                }
            }
            if (!_this.formData.depot_id) {
                _this.formData.depot_id = _this.storeOptions[0].depot_id;
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    SendGoodsDialog.prototype.setIsExistsInventory = function () {
        var _this = this;
        if (!this.formData.outOrganId) {
            this.$message.error('请先选择出库机构！');
            return;
        }
        if (!this.formData.depot_id) {
            this.$message.error('请先选择出库仓库！');
            return;
        }
        this.service.setIsExistsInventory({
            depot_id: this.formData.depot_id
        }).then(function (res) {
            if (res.data.success) {
                if (res.data.code == 8) {
                    var instance = _this.$dialog(ArticleList, {
                        data: {
                            resData: res.data
                        }
                    }, {
                        title: "提示",
                        width: 450,
                        height: 350
                    }).instance;
                    instance.$on("addClient:ok", function (data) {
                        if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                            GlobalVue.$emit('addTab', {
                                component: Client,
                                title: '合作客户',
                                name: '合作客户',
                                showExist: true,
                                cprops: {}
                            });
                        }
                    });
                }
                else {
                    _this.$emit('addClient:ok', {
                        organ_id: _this.formData.outOrganId,
                        depot_id: _this.formData.depot_id
                    });
                }
                _this.close();
            }
            else {
                _this.$message.error(res.data.msg);
                return;
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    SendGoodsDialog.prototype.close = function () {
        this.$closeDialog();
    };
    __decorate([
        Watch('formData.outOrganId')
    ], SendGoodsDialog.prototype, "watch_outOrganId", null);
    SendGoodsDialog = __decorate([
        Component
    ], SendGoodsDialog);
    return SendGoodsDialog;
}(VueDialog));
export default SendGoodsDialog;
